<template>
  <transition appear name="fade">
    <Modal v-if="modal.show" class="ModalPrompt" :isNested="modal.isNested" @close="close">
      <h3 v-if="modal.name" class="ModalPrompt-name">
        {{ modal.name }}
      </h3>
      <div class="text" :class="{ withIcon: modal.icon }">
        <Icon v-if="modal.icon" :name="modal.icon" />
        {{ modal.text }}
        <div v-if="modal.typeConfirm" class="type-confirm">
          <Field
            :label="`If you want to proceed, please type in '${modal.typeConfirm}':`"
            name="delete-prompt"
            :placeholder="modal.typeConfirm"
            :value.sync="typeConfirm" />
        </div>
      </div>
      <Row class="actions-row">
        <Column
          v-for="action in modal.actions"
          :key="action.label"
          :xs="12 / modal.actions.length">
          <Btn
            :class="action.theme"
            :disabled="isActionDisabled(action)"
            @click="process(action.action)">
            {{ action.label }}
          </Btn>
        </Column>
      </Row>
    </Modal>
  </transition>
</template>

<script>
import { actions, getters } from '@utils'

export default {
  data() {
    return {
      typeConfirm: null,
    }
  },
  computed: getters('modal'),
  methods: {
    process(actionName) {
      if (typeof actionName === 'function') {
        actionName(this)
      } else if (typeof this[actionName] !== 'undefined') {
        this[actionName]()
      }
    },
    close() {
      this.CLOSE_MODAL()
    },
    confirm() {
      this.modal.confirm()
      this.close()
    },
    isActionDisabled(action) {
      return action.action === 'confirm' &&
        (this.modal.typeConfirm && this.modal.typeConfirm !== this.typeConfirm)
    },
    ...actions('CLOSE_MODAL'),
  },
}
</script>

<style lang="scss">
.Modal.ModalPrompt {
  .ModalPrompt-name {
    padding: 1.5rem 0;
    text-align: center;
  }

  .actions-row {
    padding: 1.5rem;
  }
}
</style>
